module.exports = __webpack_public_path__ + "static/media/wedge-wheel.74fb5a5f.png";